/* eslint-disable max-len */
import { appVariant } from '@util/AppUtils';
import { Experiments } from '../helpers/experiments';
import { store } from '../store/Store';
import { hasMedicareAccessEntryInURL, hasReferralInURL } from './AssessmentUtils';
import { FlowConfig } from './FlowTypes';
import { MENO_CONFIG, MenoAssessmentScreen } from './meno/MenoConfig';
import { NERVA_CONTROL_CONFIG, NervaControlScreen } from './nerva/NervaControl';
import { NERVA_HCP_REFERRED_PERSONALISE_CONFIG } from './nerva/NervaHCPReferredPersonalise';
import { PAIN_CONTROL_CONFIG, PainControlAssessmentScreen } from './pain/PainControlConfig';
import { QUIT_CONFIG, QuitAssessmentScreen } from './quit/QuitConfig';

type NervaFlowConfig = FlowConfig<NervaControlScreen>;
type MenoFlowConfig = FlowConfig<MenoAssessmentScreen>;
type QuitFlowConfig = FlowConfig<QuitAssessmentScreen>;
type PainFlowConfig = FlowConfig<PainControlAssessmentScreen>;

export type FlowConfigs = NervaFlowConfig | MenoFlowConfig | QuitFlowConfig | PainFlowConfig;

type Options = { markExperimentsViewed?: boolean };

export function chooseAssessmentConfig(options?: Options): FlowConfigs {
  return appVariant<FlowConfigs>({
    nerva: selectNervaConfig(options),
    meno: MENO_CONFIG,
    quit: QUIT_CONFIG,
    pain: PAIN_CONTROL_CONFIG,
  });
}

function selectNervaConfig(options?: Options): FlowConfigs {
  const { referral } = store.getState();
  // Wearable users are always assigned the HCP Personalise config. Overriding here ensures viewed() and
  // select() below match what the user sees (wearable is referred-only).
  if (referral.isWearableProvided === true) {
    Experiments.NervaConfig.overrideVariant(Experiments.NervaConfig.variants.ReferredPersonalise);
  }

  // 65+ re-engagement entry lands mid-flow on the Medicare-type screen, so it forces the config whose
  // direct/referred re-entry point initializeApp knows about.
  if (hasMedicareAccessEntryInURL()) {
    Experiments.NervaConfig.overrideVariant(
      hasReferralInURL()
        ? Experiments.NervaConfig.variants.ReferredPersonalise
        : Experiments.NervaConfig.variants.Default
    );
  }

  if (options?.markExperimentsViewed) {
    Experiments.NervaConfig.viewed();
  }

  // NervaConfig variant strings encode referred vs direct pool; FlowConfigExperiment assigns by URL on first visit.
  return Experiments.NervaConfig.select({
    Default: NERVA_CONTROL_CONFIG,
    ReferredPersonalise: NERVA_HCP_REFERRED_PERSONALISE_CONFIG,
  });
}
